import React, { useEffect, useState } from 'react';

import { FormMudas } from '../../components/FormMudas';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarMudasPage(props) {

    const [mudas, setMudas] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingMudas, setErrorGettingMudas] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idMudas] = useState(props.match.params.id)

    const getMudas = async (id) => {
        setIsLoading(true);

        try {
            const response = await api.get(`mudas/${id}`)
            
            setMudas({
                'id': response.data.id,
                'nome': response.data.nome,          
            })

            setErrorGettingMudas(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingMudas(true)
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getMudas(idMudas)
    }, [])

    return (
        <>
            <MenuMain >
                {
                    errorGettingMudas ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getMudas(idMudas)}
                            isLoading={isLoading}
                        />
                        :
                        <FormMudas
                            defaultValues={mudas}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
